import { render, staticRenderFns } from "./search.component.vue?vue&type=template&id=638adc21&scoped=true&"
import script from "./search.component.vue?vue&type=script&lang=ts&"
export * from "./search.component.vue?vue&type=script&lang=ts&"
import style0 from "./search.component.vue?vue&type=style&index=0&id=638adc21&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638adc21",
  null
  
)

export default component.exports